import React, { useEffect } from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import { locationLink } from "../../data/ContactsData";
import ContactFormSection from "../home/contactFormSection/ContactFormSection";

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ bgcolor: "#f9fafb", minHeight: "100vh", pb: 8 }}>
      {/* Header */}
      <Box
        sx={{
          bgcolor: "#1f2937",
          color: "white",
          py: 8,
          textAlign: "center",
          mb: 6,
        }}
      >
        <Container>
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#9d722d" }}
          >
            Contact Us
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: "normal", opacity: 0.9 }}>
            Get in touch with us for your dream project
          </Typography>
        </Container>
      </Box>

      <Container>
        <Grid container spacing={6}>
          {/* Contact Info */}
          {/* <Grid item xs={12} md={5}>
            <Paper elevation={2} sx={{ p: 4, height: "100%", borderRadius: 2 }}>
              <Typography
                variant="h5"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#1f2937", mb: 4 }}
              >
                Contact Information
              </Typography>

              <Box sx={{ display: "flex", gap: 2, mb: 4 }}>
                <Box
                  sx={{
                    bgcolor: "#fff8e6",
                    p: 1.5,
                    borderRadius: "50%",
                    height: "fit-content",
                  }}
                >
                  <LocationOnIcon sx={{ color: "#9d722d" }} />
                </Box>
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Our Office
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {contactsDetails.location} <br />
                    Postal Code: {contactsDetails.postalCode}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", gap: 2, mb: 4 }}>
                <Box
                  sx={{
                    bgcolor: "#fff8e6",
                    p: 1.5,
                    borderRadius: "50%",
                    height: "fit-content",
                  }}
                >
                  <PhoneIcon sx={{ color: "#9d722d" }} />
                </Box>
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Phone
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {contactsDetails.phone}                    
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", gap: 2, mb: 4 }}>
                <Box
                  sx={{
                    bgcolor: "#fff8e6",
                    p: 1.5,
                    borderRadius: "50%",
                    height: "fit-content",
                  }}
                >
                  <EmailIcon sx={{ color: "#9d722d" }} />
                </Box>
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Email
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {contactsDetails.email}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <Box
                  sx={{
                    bgcolor: "#fff8e6",
                    p: 1.5,
                    borderRadius: "50%",
                    height: "fit-content",
                  }}
                >
                  <AccessTimeIcon sx={{ color: "#9d722d" }} />
                </Box>
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Office Hours
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Mon - Sat: 9:00 AM - 6:00 PM <br />
                    Sunday: Closed
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid> */}

          {/* Contact Form */}
        </Grid>
        <ContactFormSection />
        {/* Map Section */}
        <Box
          sx={{
            mt: 8,
            height: "400px",
            width: "100%",
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: 2,
          }}
        >
          <iframe
            src={locationLink}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Office Location"
          ></iframe>
        </Box>
      </Container>
    </Box>
  );
}
